import { faSpinnerThird } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { twMerge } from "tailwind-merge";
import { jsx } from "react/jsx-runtime";
//#region src/loader/Loader.tsx
const Loader = ({ variant = "absolute", size = "xl", className, ...rest }) => {
	return /* @__PURE__ */ jsx("div", {
		className: twMerge(variant === "absolute" && "absolute inset-0", variant === "static" && "static", "flex items-center justify-center text-gray-500", className),
		...rest,
		children: /* @__PURE__ */ jsx(FontAwesomeIcon, {
			size,
			className: "animate-spin",
			icon: faSpinnerThird
		})
	});
};
//#endregion
export { Loader };
